/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Office_Audit_DetailInputs */



/**
* | output |
* | --- |
* | "A review of a company's shore-side management systems, procedures and records. We check that the office structure supports safe operations and that documente..." |
*
* @param {Service_Office_Audit_DetailInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const service_office_audit_detail = /** @type {((inputs?: Service_Office_Audit_DetailInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Office_Audit_DetailInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("审查公司的岸基管理体系、程序和记录。我们检查办公室架构能否支持安全运营，以及书面程序是否在实际中得到执行。")
	return /** @type {LocalizedString} */ ("A review of a company's shore-side management systems, procedures and records. We check that the office structure supports safe operations and that documented procedures are followed in practice.")
});